import angular from 'angular';
import {QueuedTasks} from '@common/model/QueuedTasks';
import {PostTypeEnums} from "@common/model/_adocument";
import {TOAST_STATUS, UPL_TOASTID_PREFIX} from "@common/model/constants";
import {Discussion} from "@common/model/discussion";
import {ILoggingService} from "@common/service/logging.service";
import {SnackbarService} from "@common/service/snackbar.service";
import {IAppRootScopeService} from "@app/app.definition";
import {PaymentService} from "@common/service/payment.service";
import {BroadcastService} from "@common/service/broadcast.service";
import {CommonService} from "@common/common.service";
import {JavaApiAdapterService} from "@common/apiadapter/javaapi.service";
import {TeamVaultService} from "@common/service/teamvault.service";
import {UserStateService} from "@common/service/userState.service";
import {CacheService} from "@common/service/cache.service";
import {PopUpService} from "@common/popup/popup.service";
import {FeedService} from "@common/service/feed.service";
import {CachingService} from "@common/service/caching.service";
import {LoggingDetail} from "@common/model/loggingDetail";
import { BlobServiceClient } from '@azure/storage-blob';

export interface IMultipleUploadService {
    items;
    tasks;
    userLoggedOut: boolean;
}

export class MultipleUploadService implements IMultipleUploadService {
    items = [];
    tasks: QueuedTasks;
    logDetail;
    events;
    totalSelectedItems = 0;
    createdMetadata = [];
    userLoggedOut: boolean;
    reset: Function;
    uploadFileWithMsal: (params: any, document: any, storageConfig: any) => Promise<any>;

    //Show error on toast if action fails
    showErrorToast = (toastId?) => {
        if (!!toastId) {
            this.changeToastStatus("#" + toastId, TOAST_STATUS.FAILED);
        } else {
            for (let doc of this.items) {
                let tId = "#" + UPL_TOASTID_PREFIX + doc.uplId;
                if (this.currentToastStatus(tId) == TOAST_STATUS.QUEUED && !this.tasks.itemInQueue(doc.id)) {
                    this.changeToastStatus(tId, TOAST_STATUS.FAILED);
                    this.setDone(doc.uplId, false);
                }
            }
        }
    }
    //Changes the status of the toast msgs - Queued, In Progress or Failed
    changeToastStatus = (elemId, status) => {
        $(elemId).removeClass();
        $(elemId).addClass(status);
    }

    setDone = (itemId, deactivate) => {
        this.tasks.done(itemId, deactivate);
        let index = this.items.findIndex(d => d.uplId == itemId);
        if (index != -1) {
            this.items.splice(index, 1);
        }
    }
    currentToastStatus = (elemId) => {
        return $(elemId).attr('class');
    }

    unloadFunction = (e) => {
        let context = this;

        if (!!context.docUpldInProgress()) {
            let confirmationMessage = "Upload is in progress. Are you sure you want to leave and cancel all uploads?";
            e.returnValue = confirmationMessage;
            return confirmationMessage;
        }
    }

    docUpldInProgress = () => {
        //`items` holds every document from the moment it is queued until its upload
        //settles (see setDone). It is the authoritative state - the toast scan below
        //only reflects it once the progress callback has repainted the toast, which
        //lags for large files because the Azure SDK reports progress per block.
        if (this.items.length > 0) {
            return true;
        }
        let inProgress = false;
        let doc_toastr = $('#toast-container-main').find('div[id^="upld-doc-"]').toArray();
        for (let dt of doc_toastr) {
            let status = this.currentToastStatus('#' + dt.id) || '';
            if (status.includes(TOAST_STATUS.QUEUED) || status.includes(TOAST_STATUS.IN_PROGRESS)) {
                inProgress = true;
                break;
            }
        }
        return inProgress;
    }

    startUploadTasks = (items) => {
        let context = this;
        let bucket = (this.ecareEnv == "ecv-dev" ? "dev" : (this.ecareEnv == 'qa2' ? 'qa' : this.ecareEnv)) + '-doc-upload-ecarevault-com';

        for (let document of items) {
            let toastId = UPL_TOASTID_PREFIX + document.uplId;
            let elemId = "#" + toastId;
            let onCloseFunc = function () {
                console.log("CANCELLED-------: " + document.uplId);
                let docId = $(elemId).attr("doc-id");
                let toastStatus = context.currentToastStatus(elemId);
                context.$_snack.cleanup(toastId);

                if (toastStatus.includes(TOAST_STATUS.QUEUED)) {
                    //Change doc card status to fail and update in cache
                    context.$_feed.updateFeedInLocalCache([{id: docId}], "posts", true, true).then(() => {
                        context.BroadcastService.broadcast('document-failed', [docId]);
                    })
                    //Add into cancelled tasks
                    context.tasks.cancel(document.uplId);
                } else if (toastStatus.includes(TOAST_STATUS.IN_PROGRESS)) {
                    //Add into cancelled tasks
                    context.tasks.cancel(document.uplId);
                }
            }
            console.log("ADDING-------: " + document.uplId);
            let msg = "<i class='fa fa-upload doc-action-icon'></i>" + document.title;
            if (document.postType != PostTypeEnums.LINK) {
                msg += "." + document.extension;
            }
            msg += "<div class='action-queued' id='" + toastId + "'>" +
                "<i id='progress-error-txt'>Upload Failed</i>" +
                "<i id='queued-txt'>Queued for Upload</i>" +
                "<i id='processing'>Securely Storing Document</i>" +
                "<i id='upload-cmplt'>Upload Complete - Click to view</i>" +
                "<div id='progressCntr'><div id='progressBar'></div></div></div>";
            this.$_snack.showDocDwnldToastr({message: msg, notificationId: toastId}, onCloseFunc);

            this.items.push(document);
            this.saveDocument(document, bucket);
        }
        this.totalSelectedItems += items.length;
        this.tasks.totalItems += items.length;
        //Call runTask only if it is not already running
        if (items.length > 0 && this.tasks.totalItems == items.length) {
            this.tasks.runTask();
            window.addEventListener("beforeunload", context.unloadFunction, true);
        }
    }

    startProcessing = () => {
        let context = this;
        let docArray = [], docIdArray = [];

        while (this.createdMetadata.length > 0) {
            let params = this.createdMetadata.splice(0, 1);
            if (!!context.tasks.isCancelled(params[0].itemId)) {
                context.setDone(params[0].itemId, false);
            } else {
                docArray.push(params[0].document);
                docIdArray.push(Number(params[0].document.id));
                this.tasks.add(params[0]);
            }
            this.totalSelectedItems--;
        }
        //Add the new post into feeds
        context.$_feed.addNewDocsFeed(docArray, "documents").then(() => {
            this.BroadcastService.broadcast('new-document', [docArray[0].documentFolderId]);
        }, (e) => {
            console.log(e);
        });
    }

    saveDocument(doc, bucket): void {
        let toastId = UPL_TOASTID_PREFIX + doc.uplId;
        let elemId = "#" + toastId;
        let subject = this.$_cache.getCurrentSubject();
        this.$_userState.setState('USER_ADDED_DOC', true);

        if (!this.$_team.checkDocument(doc)) {
            this.$rootScope.mainShowLoader = false;
            return;
        }

        let context = this;
        doc['userId'] = context.$_cache.getUser().userId;
        !!doc.subjectId && (doc.subject = subject);

        if (!doc.documentType)
            doc.documentType = 'DOCUMENT';

        if (!!doc.postDate)
            doc.activityDate = new Date(doc.postDate).getTime();

        let sharedUserIds = "";
        let userpermissionTypes = "";
        let orgIds = "";
        let orgPermissionTypes = "";
        for (let tm of doc.documentUsers || []) {
            if (tm.permissionType != 'NOT_SHARED') {
                sharedUserIds += tm.id + " ";
                userpermissionTypes += tm.permissionType + " ";
            }
        }
        doc.orgUsers.forEach(org => {
            orgIds += org.id + " ";
            orgPermissionTypes += org.permissionType + " ";
        });
        if (!!context.tasks.isCancelled(doc.uplId)) {
            context.setDone(doc.uplId, false);
        } else {
            context.$_team.createDocumentMetadata(doc, doc.documentFolderId, null, sharedUserIds, userpermissionTypes).then(
                (d) => {
                    context.$_caching.getDiscussionObjects([d]).then(docs => {
                        let document = docs[0];
                        if (!document.owner) {
                            document.owner = context.$_cache.getUser();
                            document = new Discussion().deserialize(document);
                        }

                        document.ownerId = document.owner.id;
                        context.$_cache.setTempDocument(null);

                        if (!!doc.documentUsers) {
                            let docUsers = document.documentUsers;
                            document.documentUsers = docUsers.concat(doc.documentUsers);
                        }
                        document['uploading'] = true;
                        document['failed'] = false;

                        let tags = {
                            documentId: document.id,
                            sharedUserId: sharedUserIds.trim(),
                            shareType: userpermissionTypes.trim(),
                            folderType: doc.documentFolderType,
                            sharedOrgIds: '',
                            shareTypesOrgs: ''
                        };

                        if (!!orgIds && !!orgPermissionTypes) {
                            tags.sharedOrgIds = orgIds.trim();
                            tags.shareTypesOrgs = orgPermissionTypes.trim();
                        } else {
                            delete tags.sharedOrgIds;
                            delete tags.shareTypesOrgs;
                        }

                        let params = {
                            photoFile: doc.photoFile,
                            itemId: doc.uplId,
                            tags: tags,
                            bucket: bucket,
                            document: document
                        };
                        $(elemId).attr("doc-id", document.id);
                        this.createdMetadata.push(params);
                        if (this.totalSelectedItems == this.createdMetadata.length) {
                            context.startProcessing();
                        }
                    });
                }, () => {
                    context.showErrorToast(toastId);
                    context.setDone(doc.uplId, false);
                    context.totalSelectedItems--;
                    if (context.totalSelectedItems == context.createdMetadata.length) {
                        context.startProcessing();
                    }
                }
            );
        }
    }

    static $inject = ['LoggingService', 'SnackbarService', 'TeamVaultService', 'UserStateService',
        '$rootScope', 'PaymentService', 'CacheService', 'PopUpService', '$timeout', 'BroadcastService',
        'FeedService', '$state', 'CommonService', 'ApiAdapterService', 'authConfig', 'storageConfig', 'CachingService', 'ecareEnv'];

    constructor(
        private $_log: ILoggingService,
        private $_snack: SnackbarService,
        private $_team: TeamVaultService,
        private $_userState: UserStateService,
        private $rootScope: IAppRootScopeService,
        private PaymentService: PaymentService,
        private $_cache: CacheService,
        private $_pop: PopUpService,
        private $timeout: angular.ITimeoutService,
        private BroadcastService: BroadcastService,
        private $_feed: FeedService,
        private $state: angular.ui.IStateService,
        private CommonService: CommonService,
        private ApiAdapterService: JavaApiAdapterService,
        authConfig: any,
        storageConfig: any,
        private $_caching: CachingService,
        private ecareEnv: string
    ) {
        this.tasks = new QueuedTasks(5);
        this.events = $_log.events;

        this.uploadFileWithMsal = (params: any, document: any, storageConfig: any): Promise<any> => {
            const sasToken = this.$_cache.getSASSToken().sasToken;
            const storageUrl = storageConfig.url;
            const containerName = params.bucket;

            const blobServiceClient = new BlobServiceClient(`${storageUrl}?${sasToken}`);
            const containerClient = blobServiceClient.getContainerClient(containerName);

            const ext = this.CommonService.getExtension(params.photoFile.name.toLowerCase());
            const blobName = `${document.id}.${ext}`;
            const blockBlobClient = containerClient.getBlockBlobClient(blobName);
            let toastId = UPL_TOASTID_PREFIX + params.itemId;
            let elemId = "#" + toastId;
            let context = this;

            const progressCallback = (progress) => {
                const percent = Math.round((progress.loadedBytes / params.photoFile.size) * 100);

                if (!!context.userLoggedOut || !!context.tasks.isCancelled(params.itemId)) {
                    console.log("ABORTED: ", params.itemId, '-----', document.id);
                    //req.abort();
                } else {
                    context.$timeout(function () {
                        let elem = $(elemId).find('#progressBar');
                        context.changeToastStatus(elemId, TOAST_STATUS.IN_PROGRESS);
                        elem.css({"width": percent + '%'});
                        elem.html(percent * 1 + '%');
                    }, 10);
                }
            };

            return blockBlobClient.uploadData(params.photoFile, {
                blobHTTPHeaders: { blobContentType: params.photoFile.type },
                tags: params.tags,
                onProgress: progressCallback,
                maxSingleShotSize: 4 * 1024 * 1024 // 4MB block size
            });
        }

        this.tasks.action = (params) => {
            console.log("Uploading to Azure Container!", params.document.id);
            let context = this;
            let document = params.document;
            let toastId = UPL_TOASTID_PREFIX + params.itemId;
            let elemId = "#" + toastId;

            let startTime = Date.now();

            if (!!context.tasks.isCancelled(params.itemId)) {
                context.setDone(params.itemId, true);
                context.$_feed.updateFeedInLocalCache([{id: document.id}], "posts", true, true)
            } else {
                if (document.postType != PostTypeEnums.LINK) {
                    try {
                        context.uploadFileWithMsal(params, document, storageConfig).then(() => {
                            context.setDone(params.itemId, true);
                            context.logDetail = new LoggingDetail(context.events.UPLOAD_DOC, document.id, startTime, Date.now(), true);
                            context.$_log.logAction(context.logDetail);
                            console.log("Successfully uploaded!");
                            document['uploading'] = true;
                            document['failed'] = false;
                            // console.log('document being added to feeds:', document);

                            context.$timeout(function () {
                                let pr = $(elemId).parents('.ecv-toast-doc');
                                let closeBtn = pr.find(".fa-trash");
                                closeBtn.removeClass("fa-trash");
                                closeBtn.addClass("fa-times");
                                context.changeToastStatus(elemId, TOAST_STATUS.PROCESSING);
                                $(elemId).addClass(UPL_TOASTID_PREFIX + document.id);
                            }, 10);
                        }).catch((error) => {
                            context.setDone(params.itemId, true);
                            console.log('error uploading file to azure', error);
                            console.log("Error: " + error);
                            context.showErrorToast(toastId);
                            context.logDetail = new LoggingDetail(context.events.UPLOAD_DOC, document.id, startTime, Date.now(), false, null, null, error);
                            context.$_log.logAction(context.logDetail);
                            context.$_feed.updateFeedInLocalCache([{id: document.id}], "posts", true, true).then(() => {
                                context.BroadcastService.broadcast('document-failed', [document.id]);
                            });
                        });
                    } catch (error) {
                        console.log('Error', error);
                    }
                } else {
                    //In case of LINK UPLOAD, azure upload part will be skipped so manually handling the toasts message and updating feeds

                    //For making tasks done from the queue
                    context.setDone(params.itemId, true);
                    let pr = $(elemId).parents('.ecv-toast-doc');
                    let closeBtn = pr.find(".fa-trash");
                    closeBtn.removeClass("fa-trash");
                    closeBtn.addClass("fa-times");
                    context.changeToastStatus(elemId, TOAST_STATUS.COMPLETE);
                    $(elemId).addClass(UPL_TOASTID_PREFIX + document.id);
                    $(elemId).parents('.ecv-toast-doc').click(function () {
                        $_snack.clearNotificationToastr(toastId);
                        $state.go('documents-load', {
                            action: 'view-document',
                            stateParams: {
                                documentId: document.id,
                                folderId: document.documentFolderId,
                                postType: PostTypeEnums.LINK
                            }
                        });
                    });

                    BroadcastService.broadcast('link-uploaded', [document.id]);
                }
            }
        }

        this.tasks.resetAction = () => {
            this.items = [];
            this.tasks.totalItems = 0;
            window.removeEventListener("beforeunload", this.unloadFunction, true);
        }

        //To re-initialize all variables
        this.reset = () => {
            this.items = [];
            this.userLoggedOut = true;
            this.tasks.totalItems = 0;
            this.tasks.queue = [];
            this.tasks.cancelled = [];
            this.createdMetadata = [];
            this.totalSelectedItems = 0;
            window.removeEventListener("beforeunload", this.unloadFunction, true);
        }
    }
}

angular.module('eCareVault.common.uploadDocuments')
    .service('MultipleUploadService', MultipleUploadService);
